import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-healthcare-services',
  templateUrl: './healthcare-services.component.html',
  styleUrls: ['./healthcare-services.component.scss']
})
export class HealthcareServicesComponent {
  constructor(private router: Router) { }

  navigateTo(health: string) {
    const route = 
      health === 'Doctors' ? '/doctors' :
      health === 'Hospitals' ? '/hospitals' :
      health === 'Labs' ? '/labs' :
      '/clinics';

    this.router.navigate([route], { state: { health: health } });
  }
}